import { Fragment, useMemo } from "react";
import { useTranslation } from "react-i18next";
import {
  UserAddOutlined,
  CheckCircleOutlined,
  DollarCircleOutlined,
  LineChartOutlined,
  ArrowRightOutlined,
  RightOutlined,
} from "@ant-design/icons";
import "../style.css";

const iconByKey: Record<string, JSX.Element> = {
  recruitment: <UserAddOutlined />,
  attendance: <CheckCircleOutlined />,
  payroll: <DollarCircleOutlined />,
  performance: <LineChartOutlined />,
};

interface WorkflowFlowProps {
  className?: string;
  variant?: "default" | "compact";
}

const WorkflowFlow = ({ className = "", variant = "default" }: WorkflowFlowProps) => {
  const { t } = useTranslation("hrm");
  const isCompact = variant === "compact";

  const steps = useMemo(() => {
    const raw = t("workflow.steps", { returnObjects: true }) as unknown;
    if (!Array.isArray(raw)) return [];
    return raw as Array<{ key: string; label: string }>;
  }, [t]);

  return (
    <div
      className={[
        "dev-hrm-workflow-grid",
        isCompact ? "dev-hrm-workflow--compact" : "",
        className,
      ]
        .filter(Boolean)
        .join(" ")}
    >
      <div className="dev-hrm-workflow-track">
        {steps.map((step, idx) => (
          <Fragment key={step.key}>
            {isCompact ? (
              <div className="dev-hrm-step-item">
                <div className={`dev-hrm-step-card dev-hrm-step-card--${step.key}`}>
                  <div className="dev-hrm-step-icon">{iconByKey[step.key] ?? <RightOutlined />}</div>
                </div>
                <div className="dev-hrm-step-title">{step.label}</div>
              </div>
            ) : (
              <div className={`dev-hrm-step-card dev-hrm-step-card--${step.key}`}>
                <div className="dev-hrm-step-icon">{iconByKey[step.key] ?? <RightOutlined />}</div>
                <div className="dev-hrm-step-title">{step.label}</div>
              </div>
            )}
            {idx < steps.length - 1 && (
              <div className="dev-hrm-step-connector" aria-hidden>
                <ArrowRightOutlined />
              </div>
            )}
          </Fragment>
        ))}
      </div>
    </div>
  );
};

export default WorkflowFlow;
